/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/prop-types */
import React from 'react';
// components
import { Grid, Radio, Button, Input } from '@design-system-coopeuch/web';
import CaseInfo from '../../molecules/CaseInfo/CaseInfo';
// utils
import { isMobile } from '../../../utils/platform';
// styles
import { WrapperRadio, StyledWrapperInputMaxLength } from '../../../assets/styles/styles';

// constants
const isDeviceMobile = isMobile();

const Abandonment = (props) => {
  const {
    state,
    currentEdgeCase,
    optionSelected,
    question,
    canContinue,
    onRetrySendResponses,
    onSendResponses,
    onSelectOption,
    onResumeContratation,
    onChangeComment,
    onExitFlow,
  } = props;

  return (
    <>
      {state === 'initial' && (
        <section className="content-survey-abandonment p-0 d-flex flex-column justify-content-around">
          <article className="px-4 pl-md-6 pr-md-7 py-4 py-md-5 border-bottom border-neutral-alfa-15">
            <p className="pr-6 font-size-18 font-size-md-24 line-height-24 line-height-md-32 font-weight-500">
              Tu opinión es muy importante para mejorar tu experiencia y la de nuestros socios.
              Contesta por favor:
            </p>

          </article>
          <Grid className="p-0 px-4 px-md-6 py-4 py-md-5">
            <p className="mb-2 font-size-16 font-weight-500">¿Por qué estás abandonando?</p>
            {question.alternatives.map((el) => (
              <>
                <WrapperRadio>
                  <Radio
                    name={el.idOption}
                    label={el.description}
                    checked={optionSelected?.idOption && optionSelected?.idOption === el.idOption}
                    onChange={() => onSelectOption({ idOption: el.idOption, selected: true })}
                  />
                </WrapperRadio>
                {el.comment &&
                  optionSelected?.idOption &&
                  optionSelected?.idOption === el.idOption && (
                    <article className="mt-3">
                      <StyledWrapperInputMaxLength>
                        <Input
                          label={el.comment.question}
                          value={optionSelected?.comment}
                          maxLength={200}
                          showLength
                          assistText={
                            el.comment.required
                              ? [{ text: 'Campo obligatorio', type: 'assist' }]
                              : [{ text: 'Campo opcional', type: 'assist' }]
                          }
                          onChange={(value) =>
                            onChangeComment({ idOption: el.idOption, comment: value })
                          }
                          allowSpaces
                          autoComplete="new-password"
                        />
                      </StyledWrapperInputMaxLength>
                    </article>
                  )}
              </>
            ))}
          </Grid>
          <article className="w-100 px-4 px-md-6 py-4 py-md-5 border-top border-neutral-alfa-15 d-flex flex-column flex-md-row-reverse justify-content-md-between">
            <Button
              className="mb-1 mb-md-0 w-100 max-width-md-250 d-flex justify-content-center"
              disabled={!canContinue}
              variant="default"
              onClick={onSendResponses}
              color="primary"
            >
              Enviar y abandonar
            </Button>
            <Button
              className="w-100 max-width-md-250 d-flex justify-content-center justify-content-md-start pl-md-0"
              variant="text"
              prefix="old-arrow-left"
              onClick={onResumeContratation}
              color="primary"
            >
              Retomar contratación
            </Button>
          </article>
        </section>
      )}
      {state === 'error' && (
        <Grid className="content-survey-abandonment">
          <CaseInfo
            edgeCase={currentEdgeCase}
            isMobile={isDeviceMobile}
            onClickButton={onRetrySendResponses}
          />
        </Grid>
      )}
      {state === 'sent' && (
        <Grid className="content-survey-abandonment">
          <CaseInfo
            edgeCase={currentEdgeCase}
            isMobile={isDeviceMobile}
            onClickButton={() => onExitFlow('abandonment')}
          />
        </Grid>
      )}
    </>
  );
};

export default Abandonment;
